import type { ReactNode } from 'react';
import Layout from '../components/Layout';
import HomePage from '../pages/HomePage';
import ServicesPage from '../pages/ServicesPage';
import ServiceCategoryPage from '../pages/ServiceCategoryPage';
import ServiceDetailPage from '../pages/ServiceDetailPage';
import BlogPage from '../pages/BlogPage';
import BlogPostPage from '../pages/BlogPostPage';
import AboutPage from '../pages/AboutPage';
import ContactsPage from '../pages/ContactsPage';
import FaqPage from '../pages/FaqPage';
import PartnersPage from '../pages/PartnersPage';
import LegalPage from '../pages/LegalPage';
import LoginPage from '../pages/LoginPage';
import CabinetDashboardPage from '../pages/CabinetDashboardPage';
import OrdersListPage from '../pages/OrdersListPage';
import OrderDetailPage from '../pages/OrderDetailPage';
import ProfilePage from '../pages/ProfilePage';
import TeamPage from '../pages/TeamPage';
import NotificationsPage from '../pages/NotificationsPage';
import SupportPage from '../pages/SupportPage';
import TicketDetailPage from '../pages/TicketDetailPage';
import NotFoundPage from '../pages/NotFoundPage';

export interface AppRoute {
  path: string;
  element: ReactNode;
}

export const publicRoutes: AppRoute[] = [
  { path: '/', element: <Layout><HomePage /></Layout> },
  { path: '/services', element: <Layout><ServicesPage /></Layout> },
  { path: '/services/:category', element: <Layout><ServiceCategoryPage /></Layout> },
  { path: '/services/:category/:slug', element: <Layout><ServiceDetailPage /></Layout> },
  { path: '/blog', element: <Layout><BlogPage /></Layout> },
  { path: '/blog/:slug', element: <Layout><BlogPostPage /></Layout> },
  { path: '/about', element: <Layout><AboutPage /></Layout> },
  { path: '/contacts', element: <Layout><ContactsPage /></Layout> },
  { path: '/faq', element: <Layout><FaqPage /></Layout> },
  { path: '/partners', element: <Layout><PartnersPage /></Layout> },
  { path: '/legal/privacy', element: <Layout><LegalPage kind="privacy" /></Layout> },
  { path: '/legal/terms', element: <Layout><LegalPage kind="terms" /></Layout> },
  { path: '/legal/cookies', element: <Layout><LegalPage kind="cookies" /></Layout> },
  { path: '/legal/security', element: <Layout><LegalPage kind="security" /></Layout> },
  { path: '/legal/dpa', element: <Layout><LegalPage kind="dpa" /></Layout> },
  { path: '/login', element: <LoginPage /> },
  { path: '*', element: <Layout><NotFoundPage /></Layout> },
];

export interface CabinetRoute {
  path: string;
  element: ReactNode;
  index?: boolean;
}

export const cabinetRoutes: CabinetRoute[] = [
  { path: '', element: <CabinetDashboardPage />, index: true },
  { path: 'orders', element: <OrdersListPage /> },
  { path: 'orders/:public_id', element: <OrderDetailPage /> },
  { path: 'profile', element: <ProfilePage /> },
  { path: 'team', element: <TeamPage /> },
  { path: 'notifications', element: <NotificationsPage /> },
  { path: 'support', element: <SupportPage /> },
  { path: 'support/:public_id', element: <TicketDetailPage /> },
];

export const protectedRoutes: AppRoute[] = [];
